import { Paper, IconButton, Typography, TextField, Stack } from '@mui/material';
import { Delete } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

import { BaseLoadProfileDto, LoadProfileType } from '../../pv-calculator.dto';

export default function BaseLoad(props: {
    value: BaseLoadProfileDto;
    onChange: (loadProfile: BaseLoadProfileDto) => void;
    onDelete: () => void;
}) {
    const { t } = useTranslation();

    function onChange(value: string) {
        const parsed = parseFloat(value);

        props.onChange({
            type: LoadProfileType.BASE,
            annual_usage: isNaN(parsed) ? null : parsed,
        });
    }

    return (
        <Paper variant="outlined" sx={{ p: 2, position: 'relative' }}>
            <IconButton sx={{ position: 'absolute', top: 0, right: 0 }} onClick={() => props.onDelete()}>
                <Delete />
            </IconButton>

            <Stack spacing={1}>
                <Typography variant="h6">{t('Base usage')}</Typography>
                <Typography>{t('If left empty, the base usage is estimated.')}</Typography>

                <TextField
                    label={t('Base usage (kWh/a)')}
                    type="number"
                    size="small"
                    value={props.value.annual_usage ?? ''}
                    onChange={(e) => onChange(e.target.value)}
                />
            </Stack>
        </Paper>
    );
}
